import '../cursor.less';
import { useGetCursorIndex } from './use-get-cursor-index';

export const useScaleCursor = (rotate: number) => {
    const cursor = ['ns-resize', 'nesw-resize', 'ew-resize', 'nwse-resize'];
    const backSlashCursorArr = [cursor[3], cursor[0], cursor[1], cursor[2]];
    const slashCursorArr = [cursor[1], cursor[2], cursor[3], cursor[0]];
    const cursorIndex = useGetCursorIndex(rotate, 4);

    return {
        LT: backSlashCursorArr[cursorIndex],
        RB: backSlashCursorArr[cursorIndex],
        LB: slashCursorArr[cursorIndex],
        RT: slashCursorArr[cursorIndex],
    };
};
